import React from 'react';
import Immutable from 'immutable';
import {
	styled,
	Module,
	// Button,
	// Form,
	// LookupInput,
	// FormItem,
	Icon,
	ParentBoundComponent,
	DateUtils,
	TabPane,
	showMessageBox
} from 'ps-gui';

import {
	// getColumnText,
	// getColumnTextMap,
	getPhrase
} from '../../data/phrases';
import RecordingProtocolAdminModel from './recordingprotocoladminmodel';
import {
	CellBubble,
	CellMainText,
	CellSubText
} from '../portalresultsetmodule';
import {
	// exportToCsv,
	getGlobalContextChangeChecker,
	// parseRoleId
} from '../utils';
import { ReactComponent as ModuleLogo } from '../../svg/myrecordings.svg';
import {
	ModuleBodySection,
	ModuleHeaderSection,
	ModuleHeader,
	ModuleHeaderBlock
} from '../../blocks/modulesections';
import { withGlobalContext } from '../../data/globalcontext';
import Message from '../../blocks/message';
// import CheckButton from '../../components/checkbutton';
// import { getLookup } from '../../data/lookup';
import { StatusBubble } from '../submissioncomponents';
import { renderDateTimeCell } from '../commoncellrenderers';
import { getRecordingProtocolInfoFromAppState, isRecordingProtocolModifiedFromAppState } from './recordingprotocoldetailmodel';
import memoizeOne from 'memoize-one';

const formatDate = DateUtils.formatDate;

const Wrapper = styled.div`
`;

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);


const TabText = styled.span`

	.icon {
		position: relative;
		top: -1px;
	}

	.icon.left {
		margin-right: 8px;
	}

	.icon[data-name=close] {
		margin-left: 16px;
		* {
			fill: #4FC098;
		}
	}
`;


class RecordingProtocolAdminModule extends ParentBoundComponent {

	constructor() {
		super();

		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
		this.onTabSelected = this.onTabSelected.bind(this);
		this.processTabs = memoizeOne(this._processTabs.bind(this));
		this.closeRecordingProtocolDetail = this.closeRecordingProtocolDetail.bind(this);
		this.onRecordingProtocolRowAction = this.onRecordingProtocolRowAction.bind(this);

		this.customResultProps = Object.assign({}, customResultProps);
		this.customResultProps.toolBar =
			<Icon
				name="refresh"
				active
				hint={getPhrase('refresh')}
				onMouseDown={async () => {
					this.setModel(await this.getModel().refreshSearch(true));
				}}
			/>;
	}

	async closeRecordingProtocolDetail() {
		if (isRecordingProtocolModifiedFromAppState(this.getData().get('recordingProtocolDetail'))) {
			const dlgRes = await showMessageBox(getPhrase('reallyCloseModifiedRecordingProtocolDetail'), {
				type: 'confirm'
			});
			if (dlgRes !== 'yes') {
				return;
			}
		}
		this.setModel(this.getModel().closeRecordingProtocolDetail());
	}

	onTabSelected(tabId) {
		this.setModel(this.getModel().setSelectedTabId(tabId));
	}
	_processTabs(tabs) {
		// recordingRegistration
		const rpInfo = getRecordingProtocolInfoFromAppState(this.getData().get('recordingProtocolDetail'));
		return tabs.map(tab => {
			const tabId = tab.get('id');
			let text = tab.get('text');
			if (tabId === 'recordingProtocolDetail') {
				if (rpInfo.recordingProtocolId) {
					text = rpInfo.isrc || rpInfo.title;
				} else {
					text = getPhrase('recordingRegistration');
				}
				text =
					<TabText>
						<Icon
							//name={tabId}
							className="left"
						/>
						{text}
						<Icon
							name="close"
							active
							onMouseDown={e => {
								e.preventDefault();
								window.setTimeout(() => {
									this.closeRecordingProtocolDetail();
								}, 0);
							}}
						/>
					</TabText>;

			}
			return tab.set('text', text);
		});
	}


	getModel() {
		return new RecordingProtocolAdminModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		this.checkGlobalContextChange();
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	renderNoData() {
		return (
			<Message>
				{getPhrase('myRecordingsNoDataMessage')}
			</Message>
		);
	}

	async setSource(name, value) {
		this.setModel(await this.getModel().setSource(name, value));
	}

	async onRecordingProtocolRowAction(row, rowIndex, options) {
		const id = row.get('recording_protocol_id');
		this.setModel(await this.getModel().loadRecordingProtocolDetail(id));
	}

	getSelectedTabId() {
		return this.getData().get('selectedTabId') || 'recordingProtocols';
	}

	renderTabPane() {
		const tabs = this.processTabs(this.getData().get('tabs') || EMPTY_LIST);
		return (
			<TabPane
				selectedTabId={this.getSelectedTabId()}
				tabs={tabs}
				onTabSelected={this.onTabSelected}
			>
				<Block24 />
			</TabPane>
		);
	}


	renderProtocolList() {
		const data = this.getData();
		const sources = data.get('sources') || EMPTY_MAP;
		const mode = data.get('mode');
		return (
			<ModuleBodySection>
				<RowCountEtc>
					<RowCount>
						<span className="label">{getPhrase('recordingProtocolCount')}:</span>
						<span className="value">{data.getIn([
							'recordingProtocolSearch',
							'data',
							'result',
							'data',
							'pager',
							'totalCount'
						])}</span>
					</RowCount>
				</RowCountEtc>
				{this.renderTabPane()}
				<Module
					appState={data.get('recordingProtocolSearch')}
					onDataChange={newData => {
						this.setData(data.setIn(['recordingProtocolSearch', 'data'], newData));
					}}
					customResultProps={this.customResultProps}
					onRowAction={this.onRecordingProtocolRowAction}
				/>
			</ModuleBodySection>
		);
	}

	renderProtocolDetail() {
		const data = this.getData();
		const detailAppState = data.get('recordingProtocolDetail');
		return (
			<ModuleBodySection>
				<RowCountEtc>
					<RowCount>{getPhrase('recordingRegistration')}</RowCount>
					{
						/*!isRecordingProtocolDetailReadOnly(detailAppState.get('data')) && (
							<Button
								type="medium"
								negative
								text={getPhrase('cancelRecordingRegistration')}
								onAction={this.cancelRecordingProtocolEntry}
							/>
						)*/
					}
				</RowCountEtc>
				{this.renderTabPane()}
				<Module
					appState={detailAppState}
					onDataChange={newData => {
						this.setData(data.setIn(['recordingProtocolDetail', 'data'], newData));
					}}
				/>
			</ModuleBodySection>
		);
	}

	render() {
		const model = this.getModel();
		const data = this.getData();
		const selectedTabId = this.getSelectedTabId();
		const roleId = data.get('roleId');
		const roleLookup = data.get('roleLookup');
		const dpLookup = data.get('distributionPeriodLookup.' + roleId);
		const languageTimestamp = model.getLanguageTimestamp();
		return (
			<Wrapper>
				<ModuleHeaderSection>
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('RecordingProtocolAdmin')}</ModuleHeader>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				{
					selectedTabId === 'recordingProtocolDetail' ? this.renderProtocolDetail() : this.renderProtocolList()
				}
			</Wrapper>
		);
	}
}

const QuickFilterHeader = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${props => props.theme.disabledTextColor};
	margin-bottom: 8px;
`;

const QuickFilter = styled.div`
	margin-bottom: 24px;
	.checkButton {
		margin-right: 16px;
	}
`;

const RowCountEtc = styled.div`
	margin-bottom: 24px;
`;

const RowCount = styled.div`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	font-size: 20px;
	margin-right: 40px;
	.label {
		font-weight: 400;
		margin-right: 5px;
	}
	.value {
		font-weight: 900;
	}
`;

const FlexCell = styled.div`
	display: flex;
	align-items: center;
`;

const FlexCellContent = styled.div`
	flex-grow: ${props => props.flexGrow};
	flex-shrink: ${props => props.flexShrink};
`;


const cellRendererMap = Object.freeze({
	'recording': (cell, row, colIndex) => {
		const subtitle = row.get('subtitle');
		return (
			<FlexCell>
				<FlexCellContent flexGrow="1">
					<CellMainText>{cell}</CellMainText>
					{
						!!subtitle &&
						<CellSubText>{subtitle}</CellSubText>

					}
					<CellSubText>{row.get('recording_id')}</CellSubText>
				</FlexCellContent>
				{
					row.get('is_isrc_protocol') === 'Y' &&
					<FlexCellContent>
						<Icon
							name="isrcProtocol"
						/>
					</FlexCellContent>

				}
			</FlexCell>
		);
	},
	'production_release_year': (cell, row, colIndex) => {
		if (row.get('is_release_year')) {
			return '(' + cell + ')';
		} else {
			return cell;
		}
	},
	'audio_video': (cell, row, colIndex) => {
		if (!cell) {
			return null;
		} else if (cell !== 'A' && cell !== 'V') {
			cell = 'Other';
		}
		const id = 'recordingType' + cell;
		return (
			<CellBubble className={id}>
				{getPhrase(id)}
			</CellBubble>
		);
	},
	'role_id': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText className="secondary">{cell}</CellMainText>
				<CellSubText>{row.get('party_id') + ' - ' + row.get('role_type')}</CellSubText>
			</>
		);
	},
	'submission_status': (cell, row) => {
		return (
			<StatusBubble className={row.get('submission_status_id')}>{cell}</StatusBubble>
		);
	},
	last_modified: renderDateTimeCell
});



const customResultProps = {
	cellRendererMap,
	rowCountLabel: () => getPhrase('recordingCount'),
	defaultColumnWidths: {
		'audio_video': '120px',
		'length': '120px',
		'isrc': '140px',
		'production_release_year': '120px',
		'main_artist': '220px',
		'licence': '230px',
		'submission_type': '140px',
		last_modified: '120px',
		'submission_status': '180px',
		submission_id: '120px',
	},
	columnAlign: {
		submission_id: 'left',
	},
	withRowSelection: true,
	columnFilters: {
		'audio_video': {
			type: 'lookup',
			lookup: 'audioVideo'
		},
		'isrc': {
			type: 'text'
		},
		'length': {
			type: 'runtime'
		},
		'production_release_year': {
			type: 'number',
			groupless: true,
			inputSize: 4,
		},
		'submission_id': {
			type: 'number',
			groupless: true,
			inputSize: 10,
		},
		'recording': {
			type: 'text'
		},
		'main_artist': {
			type: 'text'
		},
		'submission_status': {
			type: 'lookup',
			lookup: 'recordingProtocolSubmissionStatus'
		},
		'submission_type': {
			type: 'lookup',
			lookup: 'recordingProtocolSubmissionType'
		},
		last_modified: {
			type: 'date'
		},
		role_id: {
			type: 'lookup',
			lookup: 'partyIdName'
		},
	}
};


const Block24 = styled.div`
	height: 24px;
`;

export default withGlobalContext(RecordingProtocolAdminModule);

